import { yupObject, yupString } from '../../yup';

export const trustSchema = () => {
  return yupObject({
    trustName: yupString()
      .required()
      .test('len', 'Max 128 characters', (val) => val.length <= 128)
      .label('Trust name'),
    trusteeType: yupString().required().oneOf(['individual', 'company']).label('Trustee type'),
    trustStructure: yupString().required().oneOf(['unit', 'discretionary', 'hybrid']).label('Trust structure'),
  });
};
